// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Scalars = require("../../../scalars/Scalars.bs.js");
let V4 = require("uuid/v4");
let DateFnsTz = require("../../../reason/common/DateFns/DateFnsTz.bs.js");
let UserSession = require("../../../reason/common/UserSession/UserSession.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let RelayRuntime = require("relay-runtime");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelayReact = require("rescript-relay/src/RescriptRelayReact.bs.js");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let PropertyWizardRelay__Preview__Query = require("./PropertyWizardRelay__Preview__Query.bs.js");
let PropertyWizardFormRelayQuery_graphql = require("../../../__generated__/PropertyWizardFormRelayQuery_graphql.bs.js");
let PropertyWizardFormRelayMutation_graphql = require("../../../__generated__/PropertyWizardFormRelayMutation_graphql.bs.js");
let PropertyWizardFormRelay_localDraft_graphql = require("../../../__generated__/PropertyWizardFormRelay_localDraft_graphql.bs.js");
let PropertyWizardFormRelay_serverDraft_graphql = require("../../../__generated__/PropertyWizardFormRelay_serverDraft_graphql.bs.js");
let PropertyWizardFormRelayFormStateQuery_graphql = require("../../../__generated__/PropertyWizardFormRelayFormStateQuery_graphql.bs.js");
let PropertyWizardFormRelay_inlineServerDraft_graphql = require("../../../__generated__/PropertyWizardFormRelay_inlineServerDraft_graphql.bs.js");
let PropertyWizardFormRelayBroadcastPolicy_policy_graphql = require("../../../__generated__/PropertyWizardFormRelayBroadcastPolicy_policy_graphql.bs.js");
let PropertyWizardFormRelayFormStateUpdatableQuery_graphql = require("../../../__generated__/PropertyWizardFormRelayFormStateUpdatableQuery_graphql.bs.js");

let convertFragment = PropertyWizardFormRelayBroadcastPolicy_policy_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayBroadcastPolicy_policy_graphql.node, convertFragment, fRef);
}

function readInline(fRef) {
  return RescriptRelay_Fragment.readInlineData(PropertyWizardFormRelayBroadcastPolicy_policy_graphql.node, convertFragment, fRef);
}

let PolicyFragment_broadcastNotAllowedReason_decode = PropertyWizardFormRelayBroadcastPolicy_policy_graphql.Utils.broadcastNotAllowedReason_decode;

let PolicyFragment_broadcastNotAllowedReason_fromString = PropertyWizardFormRelayBroadcastPolicy_policy_graphql.Utils.broadcastNotAllowedReason_fromString;

let PolicyFragment = {
  broadcastNotAllowedReason_decode: PolicyFragment_broadcastNotAllowedReason_decode,
  broadcastNotAllowedReason_fromString: PolicyFragment_broadcastNotAllowedReason_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  readInline: readInline
};

let convertVariables = PropertyWizardFormRelayFormStateQuery_graphql.Internal.convertVariables;

let convertResponse = PropertyWizardFormRelayFormStateQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = PropertyWizardFormRelayFormStateQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, PropertyWizardFormRelayFormStateQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, PropertyWizardFormRelayFormStateQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(PropertyWizardFormRelayFormStateQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch(PropertyWizardFormRelayFormStateQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(PropertyWizardFormRelayFormStateQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(PropertyWizardFormRelayFormStateQuery_graphql.node, convertVariables);

let commitLocalPayload = RescriptRelay_Query.commitLocalPayload(PropertyWizardFormRelayFormStateQuery_graphql.node, convertVariables, convertWrapRawResponse);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain,
  commitLocalPayload: commitLocalPayload
};

let UpdatableQuery = {
  Types: undefined,
  readUpdatableQuery: PropertyWizardFormRelayFormStateUpdatableQuery_graphql.readUpdatableQuery
};

function setDisplayNeighborhoods(parent, displayNeighborhoods) {
  parent.displayNeighborhoods = displayNeighborhoods.map(d => ({
    __id: d.__id
  }));
}

function useUpdater() {
  let environment = RescriptRelayReact.useEnvironmentFromContext();
  return React.useCallback(updater => {
    RelayRuntime.commitLocalUpdate(environment, store => {
      let match = PropertyWizardFormRelayFormStateUpdatableQuery_graphql.readUpdatableQuery(store, undefined);
      let formState = match.updatableData.localDraftFormState;
      if (formState == null) {
        return;
      } else {
        return updater(formState);
      }
    });
  }, [environment]);
}

let FormState = {
  Query: Query,
  UpdatableQuery: UpdatableQuery,
  setDisplayNeighborhoods: setDisplayNeighborhoods,
  useUpdater: useUpdater
};

let draftV5Status_decode = PropertyWizardFormRelay_localDraft_graphql.Utils.draftV5Status_decode;

let convertFragment$1 = PropertyWizardFormRelay_localDraft_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelay_localDraft_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelay_localDraft_graphql.node, convertFragment$1, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelay_localDraft_graphql.node, convertFragment$1);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelay_localDraft_graphql.node, convertFragment$1, fRef);
}

let LocalDraftFragment_draftV5Status_fromString = PropertyWizardFormRelay_localDraft_graphql.Utils.draftV5Status_fromString;

let LocalDraftFragment_forSalePropertyTypeEnumV5_decode = PropertyWizardFormRelay_localDraft_graphql.Utils.forSalePropertyTypeEnumV5_decode;

let LocalDraftFragment_forSalePropertyTypeEnumV5_fromString = PropertyWizardFormRelay_localDraft_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

let LocalDraftFragment_leaseLengthValue_decode = PropertyWizardFormRelay_localDraft_graphql.Utils.leaseLengthValue_decode;

let LocalDraftFragment_leaseLengthValue_fromString = PropertyWizardFormRelay_localDraft_graphql.Utils.leaseLengthValue_fromString;

let LocalDraftFragment_localDraftPropertyType_decode = PropertyWizardFormRelay_localDraft_graphql.Utils.localDraftPropertyType_decode;

let LocalDraftFragment_localDraftPropertyType_fromString = PropertyWizardFormRelay_localDraft_graphql.Utils.localDraftPropertyType_fromString;

let LocalDraftFragment_mlsListingTypeV5_decode = PropertyWizardFormRelay_localDraft_graphql.Utils.mlsListingTypeV5_decode;

let LocalDraftFragment_mlsListingTypeV5_fromString = PropertyWizardFormRelay_localDraft_graphql.Utils.mlsListingTypeV5_fromString;

let LocalDraftFragment_rentalPropertyTypeEnumV5_decode = PropertyWizardFormRelay_localDraft_graphql.Utils.rentalPropertyTypeEnumV5_decode;

let LocalDraftFragment_rentalPropertyTypeEnumV5_fromString = PropertyWizardFormRelay_localDraft_graphql.Utils.rentalPropertyTypeEnumV5_fromString;

let LocalDraftFragment_showingTypeV5_decode = PropertyWizardFormRelay_localDraft_graphql.Utils.showingTypeV5_decode;

let LocalDraftFragment_showingTypeV5_fromString = PropertyWizardFormRelay_localDraft_graphql.Utils.showingTypeV5_fromString;

let LocalDraftFragment = {
  draftV5Status_decode: draftV5Status_decode,
  draftV5Status_fromString: LocalDraftFragment_draftV5Status_fromString,
  forSalePropertyTypeEnumV5_decode: LocalDraftFragment_forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: LocalDraftFragment_forSalePropertyTypeEnumV5_fromString,
  leaseLengthValue_decode: LocalDraftFragment_leaseLengthValue_decode,
  leaseLengthValue_fromString: LocalDraftFragment_leaseLengthValue_fromString,
  localDraftPropertyType_decode: LocalDraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: LocalDraftFragment_localDraftPropertyType_fromString,
  mlsListingTypeV5_decode: LocalDraftFragment_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: LocalDraftFragment_mlsListingTypeV5_fromString,
  rentalPropertyTypeEnumV5_decode: LocalDraftFragment_rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: LocalDraftFragment_rentalPropertyTypeEnumV5_fromString,
  showingTypeV5_decode: LocalDraftFragment_showingTypeV5_decode,
  showingTypeV5_fromString: LocalDraftFragment_showingTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let forSalePropertyTypeEnumV5_decode = PropertyWizardFormRelay_serverDraft_graphql.Utils.forSalePropertyTypeEnumV5_decode;

let leaseLengthValue_decode = PropertyWizardFormRelay_serverDraft_graphql.Utils.leaseLengthValue_decode;

let rentalPropertyTypeEnumV5_decode = PropertyWizardFormRelay_serverDraft_graphql.Utils.rentalPropertyTypeEnumV5_decode;

let convertFragment$2 = PropertyWizardFormRelay_serverDraft_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelay_serverDraft_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelay_serverDraft_graphql.node, convertFragment$2, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelay_serverDraft_graphql.node, convertFragment$2);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelay_serverDraft_graphql.node, convertFragment$2, fRef);
}

let ServerDraftFragment_draftV5Status_decode = PropertyWizardFormRelay_serverDraft_graphql.Utils.draftV5Status_decode;

let ServerDraftFragment_draftV5Status_fromString = PropertyWizardFormRelay_serverDraft_graphql.Utils.draftV5Status_fromString;

let ServerDraftFragment_forSalePropertyTypeEnumV5_fromString = PropertyWizardFormRelay_serverDraft_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

let ServerDraftFragment_leaseLengthValue_fromString = PropertyWizardFormRelay_serverDraft_graphql.Utils.leaseLengthValue_fromString;

let ServerDraftFragment_mlsListingTypeV5_decode = PropertyWizardFormRelay_serverDraft_graphql.Utils.mlsListingTypeV5_decode;

let ServerDraftFragment_mlsListingTypeV5_fromString = PropertyWizardFormRelay_serverDraft_graphql.Utils.mlsListingTypeV5_fromString;

let ServerDraftFragment_onOrOffV5_decode = PropertyWizardFormRelay_serverDraft_graphql.Utils.onOrOffV5_decode;

let ServerDraftFragment_onOrOffV5_fromString = PropertyWizardFormRelay_serverDraft_graphql.Utils.onOrOffV5_fromString;

let ServerDraftFragment_rentalPropertyTypeEnumV5_fromString = PropertyWizardFormRelay_serverDraft_graphql.Utils.rentalPropertyTypeEnumV5_fromString;

let ServerDraftFragment_showingTypeV5_decode = PropertyWizardFormRelay_serverDraft_graphql.Utils.showingTypeV5_decode;

let ServerDraftFragment_showingTypeV5_fromString = PropertyWizardFormRelay_serverDraft_graphql.Utils.showingTypeV5_fromString;

let ServerDraftFragment = {
  draftV5Status_decode: ServerDraftFragment_draftV5Status_decode,
  draftV5Status_fromString: ServerDraftFragment_draftV5Status_fromString,
  forSalePropertyTypeEnumV5_decode: forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: ServerDraftFragment_forSalePropertyTypeEnumV5_fromString,
  leaseLengthValue_decode: leaseLengthValue_decode,
  leaseLengthValue_fromString: ServerDraftFragment_leaseLengthValue_fromString,
  mlsListingTypeV5_decode: ServerDraftFragment_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: ServerDraftFragment_mlsListingTypeV5_fromString,
  onOrOffV5_decode: ServerDraftFragment_onOrOffV5_decode,
  onOrOffV5_fromString: ServerDraftFragment_onOrOffV5_fromString,
  rentalPropertyTypeEnumV5_decode: rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: ServerDraftFragment_rentalPropertyTypeEnumV5_fromString,
  showingTypeV5_decode: ServerDraftFragment_showingTypeV5_decode,
  showingTypeV5_fromString: ServerDraftFragment_showingTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

let convertFragment$3 = PropertyWizardFormRelay_inlineServerDraft_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelay_inlineServerDraft_graphql.node, convertFragment$3, fRef);
}

function readInline$1(fRef) {
  return RescriptRelay_Fragment.readInlineData(PropertyWizardFormRelay_inlineServerDraft_graphql.node, convertFragment$3, fRef);
}

let InlineServerDraftFragment_draftV5Status_decode = PropertyWizardFormRelay_inlineServerDraft_graphql.Utils.draftV5Status_decode;

let InlineServerDraftFragment_draftV5Status_fromString = PropertyWizardFormRelay_inlineServerDraft_graphql.Utils.draftV5Status_fromString;

let InlineServerDraftFragment_forSalePropertyTypeEnumV5_decode = PropertyWizardFormRelay_inlineServerDraft_graphql.Utils.forSalePropertyTypeEnumV5_decode;

let InlineServerDraftFragment_forSalePropertyTypeEnumV5_fromString = PropertyWizardFormRelay_inlineServerDraft_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

let InlineServerDraftFragment_leaseLengthValue_decode = PropertyWizardFormRelay_inlineServerDraft_graphql.Utils.leaseLengthValue_decode;

let InlineServerDraftFragment_leaseLengthValue_fromString = PropertyWizardFormRelay_inlineServerDraft_graphql.Utils.leaseLengthValue_fromString;

let InlineServerDraftFragment_mlsListingTypeV5_decode = PropertyWizardFormRelay_inlineServerDraft_graphql.Utils.mlsListingTypeV5_decode;

let InlineServerDraftFragment_mlsListingTypeV5_fromString = PropertyWizardFormRelay_inlineServerDraft_graphql.Utils.mlsListingTypeV5_fromString;

let InlineServerDraftFragment_onOrOffV5_decode = PropertyWizardFormRelay_inlineServerDraft_graphql.Utils.onOrOffV5_decode;

let InlineServerDraftFragment_onOrOffV5_fromString = PropertyWizardFormRelay_inlineServerDraft_graphql.Utils.onOrOffV5_fromString;

let InlineServerDraftFragment_rentalPropertyTypeEnumV5_decode = PropertyWizardFormRelay_inlineServerDraft_graphql.Utils.rentalPropertyTypeEnumV5_decode;

let InlineServerDraftFragment_rentalPropertyTypeEnumV5_fromString = PropertyWizardFormRelay_inlineServerDraft_graphql.Utils.rentalPropertyTypeEnumV5_fromString;

let InlineServerDraftFragment_showingTypeV5_decode = PropertyWizardFormRelay_inlineServerDraft_graphql.Utils.showingTypeV5_decode;

let InlineServerDraftFragment_showingTypeV5_fromString = PropertyWizardFormRelay_inlineServerDraft_graphql.Utils.showingTypeV5_fromString;

let InlineServerDraftFragment = {
  draftV5Status_decode: InlineServerDraftFragment_draftV5Status_decode,
  draftV5Status_fromString: InlineServerDraftFragment_draftV5Status_fromString,
  forSalePropertyTypeEnumV5_decode: InlineServerDraftFragment_forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: InlineServerDraftFragment_forSalePropertyTypeEnumV5_fromString,
  leaseLengthValue_decode: InlineServerDraftFragment_leaseLengthValue_decode,
  leaseLengthValue_fromString: InlineServerDraftFragment_leaseLengthValue_fromString,
  mlsListingTypeV5_decode: InlineServerDraftFragment_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: InlineServerDraftFragment_mlsListingTypeV5_fromString,
  onOrOffV5_decode: InlineServerDraftFragment_onOrOffV5_decode,
  onOrOffV5_fromString: InlineServerDraftFragment_onOrOffV5_fromString,
  rentalPropertyTypeEnumV5_decode: InlineServerDraftFragment_rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: InlineServerDraftFragment_rentalPropertyTypeEnumV5_fromString,
  showingTypeV5_decode: InlineServerDraftFragment_showingTypeV5_decode,
  showingTypeV5_fromString: InlineServerDraftFragment_showingTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  readInline: readInline$1
};

function serverDraftToLocalDraft(serverDraft) {
  let match = serverDraft.chapter;
  let tmp;
  if (match !== undefined) {
    let match$1 = match.preferences;
    if (match$1 !== undefined) {
      let match$2 = match$1.mlsComingSoon;
      tmp = match$2 === "ON";
    } else {
      tmp = false;
    }
  } else {
    tmp = false;
  }
  let draftProperty = serverDraft.draftProperty;
  let tmp$1;
  if (draftProperty !== undefined) {
    let propertyData = draftProperty.propertyData;
    let commission;
    if (propertyData !== undefined) {
      switch (propertyData.__typename) {
        case "DraftPropertyDataForSaleV5" :
          commission = propertyData.commission;
          break;
        case "DraftPropertyDataRentalV5" :
        case "__unselected" :
          commission = undefined;
          break;
      }
    } else {
      commission = undefined;
    }
    let match$3 = draftProperty.price;
    let match$4;
    if (match$3 !== undefined) {
      switch (match$3.__typename) {
        case "DraftPropertyPriceRange" :
          match$4 = [
            Stdlib_Option.map(match$3.minPrice, p => p.value),
            Stdlib_Option.map(match$3.maxPrice, p => p.value),
            true
          ];
          break;
        case "DraftPropertyExactPrice" :
        case "__unselected" :
          match$4 = [
            undefined,
            undefined,
            false
          ];
          break;
      }
    } else {
      match$4 = [
        undefined,
        undefined,
        false
      ];
    }
    let match$5 = draftProperty.price;
    let price;
    if (match$5 !== undefined) {
      switch (match$5.__typename) {
        case "DraftPropertyExactPrice" :
          price = Stdlib_Option.map(match$5.price, p => p.value);
          break;
        case "DraftPropertyPriceRange" :
        case "__unselected" :
          price = undefined;
          break;
      }
    } else {
      price = undefined;
    }
    let match$6;
    if (propertyData !== undefined) {
      switch (propertyData.__typename) {
        case "DraftPropertyDataRentalV5" :
          match$6 = [
            propertyData.availableFrom,
            propertyData.leaseLength
          ];
          break;
        case "DraftPropertyDataForSaleV5" :
        case "__unselected" :
          match$6 = [
            undefined,
            undefined
          ];
          break;
      }
    } else {
      match$6 = [
        undefined,
        undefined
      ];
    }
    let match$7 = draftProperty.displayNeighborhood;
    let tmp$2;
    if (propertyData !== undefined) {
      switch (propertyData.__typename) {
        case "DraftPropertyDataForSaleV5" :
          tmp$2 = Stdlib_Option.flatMap(propertyData.forSalePropertyType, forSalePropertyTypeEnumV5_decode);
          break;
        case "DraftPropertyDataRentalV5" :
        case "__unselected" :
          tmp$2 = undefined;
          break;
      }
    } else {
      tmp$2 = undefined;
    }
    let match$8 = draftProperty.geocodingData;
    let tmp$3;
    if (match$8 !== undefined) {
      let lat = match$8.lat;
      if (lat !== undefined) {
        let lon = match$8.lon;
        if (lon !== undefined) {
          let standardizedAddress = match$8.standardizedAddress;
          if (standardizedAddress !== undefined) {
            let standardizedCity = match$8.standardizedCity;
            if (standardizedCity !== undefined) {
              let standardizedState = match$8.standardizedState;
              if (standardizedState !== undefined) {
                let standardizedZip = match$8.standardizedZip;
                tmp$3 = standardizedZip !== undefined ? ({
                    lat: lat,
                    lon: lon,
                    standardizedAddress: standardizedAddress,
                    standardizedCity: standardizedCity,
                    standardizedState: standardizedState,
                    standardizedZip: standardizedZip
                  }) : undefined;
              } else {
                tmp$3 = undefined;
              }
            } else {
              tmp$3 = undefined;
            }
          } else {
            tmp$3 = undefined;
          }
        } else {
          tmp$3 = undefined;
        }
      } else {
        tmp$3 = undefined;
      }
    } else {
      tmp$3 = undefined;
    }
    let tmp$4;
    if (propertyData !== undefined) {
      switch (propertyData.__typename) {
        case "DraftPropertyDataRentalV5" :
          tmp$4 = "RENTAL";
          break;
        case "DraftPropertyDataForSaleV5" :
        case "__unselected" :
          tmp$4 = "FOR_SALE";
          break;
      }
    } else {
      tmp$4 = "FOR_SALE";
    }
    let tmp$5;
    if (propertyData !== undefined) {
      switch (propertyData.__typename) {
        case "DraftPropertyDataRentalV5" :
          tmp$5 = Stdlib_Option.flatMap(propertyData.rentalPropertyType, rentalPropertyTypeEnumV5_decode);
          break;
        case "DraftPropertyDataForSaleV5" :
        case "__unselected" :
          tmp$5 = undefined;
          break;
      }
    } else {
      tmp$5 = undefined;
    }
    let match$9 = draftProperty.userSelectedArea;
    tmp$1 = {
      address: draftProperty.address,
      addressToGeocode: draftProperty.address,
      anonymousProperty: Stdlib_Option.getOr(draftProperty.anonymousProperty, false),
      availableFrom: match$6[0],
      baths: draftProperty.baths,
      beds: draftProperty.beds,
      commission: commission,
      description: draftProperty.description,
      displayNeighborhood: match$7 !== undefined ? ({
          id: match$7.id,
          label: match$7.label
        }) : undefined,
      files: Stdlib_Option.getOr(Stdlib_Option.map(draftProperty.files, files => Stdlib_Array.filterMap(files, f => {
        let contentType = f.contentType;
        if (contentType === undefined) {
          return;
        }
        let fileName = f.fileName;
        if (fileName !== undefined) {
          return {
            contentType: contentType,
            fileName: fileName,
            id: f.id,
            key: f.key
          };
        }
      })), []),
      forSalePropertyType: tmp$2,
      geocodingData: tmp$3,
      goingOnMls: draftProperty.goingOnMls,
      halfBaths: draftProperty.halfBaths,
      hideAddress: draftProperty.hideAddress,
      images: Stdlib_Option.getOr(Stdlib_Option.map(draftProperty.images, images => Stdlib_Array.filterMap(images, img => {
        let contentType = img.contentType;
        if (contentType === undefined) {
          return;
        }
        let fileName = img.fileName;
        if (fileName !== undefined) {
          return {
            contentType: contentType,
            fileName: fileName,
            id: img.id,
            key: img.key,
            previewUrl: img.url
          };
        }
      })), []),
      leaseLength: Stdlib_Option.flatMap(Stdlib_Option.map(match$6[1], p => p.value), leaseLengthValue_decode),
      livingArea: draftProperty.livingArea,
      lotSize: draftProperty.lotSize,
      maxPrice: match$4[1],
      minPrice: match$4[0],
      mlsListingType: draftProperty.mlsListingType,
      numberOfUnits: draftProperty.numberOfUnits,
      onMlsAt: draftProperty.onMlsAt,
      parkingDetails: draftProperty.parkingDetails,
      parkingSpaces: draftProperty.parkingSpaces,
      price: price,
      priceRange: match$4[2],
      propertyType: tmp$4,
      rentalPropertyType: tmp$5,
      selectedArea: match$9 !== undefined ? ({
          id: match$9.id,
          label: match$9.label
        }) : undefined,
      showings: Stdlib_Option.getOr(Stdlib_Option.map(draftProperty.showings, showings => showings.map(s => {
        let match = s.id;
        let match$1 = s.key;
        return {
          date: s.date,
          endTime: s.endTime,
          id: s.id,
          key: match !== undefined ? match : (
              match$1 !== undefined ? match$1 : V4()
            ),
          notes: s.notes,
          startTime: s.startTime,
          type_: s.typ
        };
      })), []),
      website: draftProperty.website,
      willAcceptOffers: draftProperty.willAcceptOffers,
      willShow: draftProperty.willShow
    };
  } else {
    tmp$1 = {
      address: undefined,
      addressToGeocode: undefined,
      anonymousProperty: false,
      availableFrom: undefined,
      baths: undefined,
      beds: undefined,
      commission: undefined,
      description: undefined,
      displayNeighborhood: undefined,
      files: [],
      forSalePropertyType: undefined,
      geocodingData: undefined,
      goingOnMls: undefined,
      halfBaths: undefined,
      hideAddress: undefined,
      images: [],
      leaseLength: undefined,
      livingArea: undefined,
      lotSize: undefined,
      maxPrice: undefined,
      minPrice: undefined,
      mlsListingType: "ACTIVE",
      numberOfUnits: undefined,
      onMlsAt: undefined,
      parkingDetails: undefined,
      parkingSpaces: undefined,
      price: undefined,
      priceRange: false,
      propertyType: "FOR_SALE",
      rentalPropertyType: undefined,
      selectedArea: undefined,
      showings: [],
      website: undefined,
      willAcceptOffers: true,
      willShow: true
    };
  }
  return {
    chapterPreferenceMlsComingSoonActivated: tmp,
    draftProperty: tmp$1,
    message: serverDraft.message,
    serverDraftId: serverDraft.databaseId,
    status: serverDraft.status,
    subject: serverDraft.subject,
    timeZone: Stdlib_Option.getOr(Stdlib_Option.flatMap(serverDraft.chapter, c => c.timezone), "")
  };
}

let convertVariables$1 = PropertyWizardFormRelayQuery_graphql.Internal.convertVariables;

let convertResponse$1 = PropertyWizardFormRelayQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = PropertyWizardFormRelayQuery_graphql.Internal.convertWrapRawResponse;

let use$3 = RescriptRelay_Query.useQuery(convertVariables$1, PropertyWizardFormRelayQuery_graphql.node, convertResponse$1);

let useLoader$1 = RescriptRelay_Query.useLoader(convertVariables$1, PropertyWizardFormRelayQuery_graphql.node, prim => prim);

let usePreloaded$1 = RescriptRelay_Query.usePreloaded(PropertyWizardFormRelayQuery_graphql.node, convertResponse$1, prim => prim);

let fetch$1 = RescriptRelay_Query.fetch(PropertyWizardFormRelayQuery_graphql.node, convertResponse$1, convertVariables$1);

let fetchPromised$1 = RescriptRelay_Query.fetchPromised(PropertyWizardFormRelayQuery_graphql.node, convertResponse$1, convertVariables$1);

let retain$1 = RescriptRelay_Query.retain(PropertyWizardFormRelayQuery_graphql.node, convertVariables$1);

let commitLocalPayload$1 = RescriptRelay_Query.commitLocalPayload(PropertyWizardFormRelayQuery_graphql.node, convertVariables$1, convertWrapRawResponse$1);

let LocalDraftSetterQuery_draftV5Status_decode = PropertyWizardFormRelayQuery_graphql.Utils.draftV5Status_decode;

let LocalDraftSetterQuery_draftV5Status_fromString = PropertyWizardFormRelayQuery_graphql.Utils.draftV5Status_fromString;

let LocalDraftSetterQuery_forSalePropertyTypeEnumV5_decode = PropertyWizardFormRelayQuery_graphql.Utils.forSalePropertyTypeEnumV5_decode;

let LocalDraftSetterQuery_forSalePropertyTypeEnumV5_fromString = PropertyWizardFormRelayQuery_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

let LocalDraftSetterQuery_leaseLengthValue_decode = PropertyWizardFormRelayQuery_graphql.Utils.leaseLengthValue_decode;

let LocalDraftSetterQuery_leaseLengthValue_fromString = PropertyWizardFormRelayQuery_graphql.Utils.leaseLengthValue_fromString;

let LocalDraftSetterQuery_localDraftPropertyType_decode = PropertyWizardFormRelayQuery_graphql.Utils.localDraftPropertyType_decode;

let LocalDraftSetterQuery_localDraftPropertyType_fromString = PropertyWizardFormRelayQuery_graphql.Utils.localDraftPropertyType_fromString;

let LocalDraftSetterQuery_mlsListingTypeV5_decode = PropertyWizardFormRelayQuery_graphql.Utils.mlsListingTypeV5_decode;

let LocalDraftSetterQuery_mlsListingTypeV5_fromString = PropertyWizardFormRelayQuery_graphql.Utils.mlsListingTypeV5_fromString;

let LocalDraftSetterQuery_rentalPropertyTypeEnumV5_decode = PropertyWizardFormRelayQuery_graphql.Utils.rentalPropertyTypeEnumV5_decode;

let LocalDraftSetterQuery_rentalPropertyTypeEnumV5_fromString = PropertyWizardFormRelayQuery_graphql.Utils.rentalPropertyTypeEnumV5_fromString;

let LocalDraftSetterQuery_showingTypeV5_decode = PropertyWizardFormRelayQuery_graphql.Utils.showingTypeV5_decode;

let LocalDraftSetterQuery_showingTypeV5_fromString = PropertyWizardFormRelayQuery_graphql.Utils.showingTypeV5_fromString;

let LocalDraftSetterQuery = {
  draftV5Status_decode: LocalDraftSetterQuery_draftV5Status_decode,
  draftV5Status_fromString: LocalDraftSetterQuery_draftV5Status_fromString,
  forSalePropertyTypeEnumV5_decode: LocalDraftSetterQuery_forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: LocalDraftSetterQuery_forSalePropertyTypeEnumV5_fromString,
  leaseLengthValue_decode: LocalDraftSetterQuery_leaseLengthValue_decode,
  leaseLengthValue_fromString: LocalDraftSetterQuery_leaseLengthValue_fromString,
  localDraftPropertyType_decode: LocalDraftSetterQuery_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: LocalDraftSetterQuery_localDraftPropertyType_fromString,
  mlsListingTypeV5_decode: LocalDraftSetterQuery_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: LocalDraftSetterQuery_mlsListingTypeV5_fromString,
  rentalPropertyTypeEnumV5_decode: LocalDraftSetterQuery_rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: LocalDraftSetterQuery_rentalPropertyTypeEnumV5_fromString,
  showingTypeV5_decode: LocalDraftSetterQuery_showingTypeV5_decode,
  showingTypeV5_fromString: LocalDraftSetterQuery_showingTypeV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  use: use$3,
  useLoader: useLoader$1,
  usePreloaded: usePreloaded$1,
  fetch: fetch$1,
  fetchPromised: fetchPromised$1,
  retain: retain$1,
  commitLocalPayload: commitLocalPayload$1
};

function localDraftToCommitable(localDraft) {
  let match = localDraft.draftProperty;
  return {
    chapterPreferenceMlsComingSoonActivated: localDraft.chapterPreferenceMlsComingSoonActivated,
    draftProperty: {
      address: match.address,
      addressToGeocode: match.addressToGeocode,
      anonymousProperty: match.anonymousProperty,
      availableFrom: match.availableFrom,
      baths: match.baths,
      beds: match.beds,
      commission: match.commission,
      description: match.description,
      displayNeighborhood: match.displayNeighborhood,
      files: match.files,
      forSalePropertyType: match.forSalePropertyType,
      geocodingData: match.geocodingData,
      goingOnMls: match.goingOnMls,
      halfBaths: match.halfBaths,
      hideAddress: match.hideAddress,
      images: match.images,
      leaseLength: match.leaseLength,
      livingArea: match.livingArea,
      lotSize: match.lotSize,
      maxPrice: match.maxPrice,
      minPrice: match.minPrice,
      mlsListingType: match.mlsListingType,
      numberOfUnits: match.numberOfUnits,
      onMlsAt: match.onMlsAt,
      parkingDetails: match.parkingDetails,
      parkingSpaces: match.parkingSpaces,
      price: match.price,
      priceRange: match.priceRange,
      propertyType: match.propertyType,
      rentalPropertyType: match.rentalPropertyType,
      selectedArea: match.selectedArea,
      showings: match.showings,
      website: match.website,
      willAcceptOffers: match.willAcceptOffers,
      willShow: match.willShow
    },
    message: localDraft.message,
    serverDraftId: localDraft.serverDraftId,
    status: Stdlib_Option.flatMap(localDraft.status, draftV5Status_decode),
    subject: localDraft.subject,
    timeZone: localDraft.timeZone,
    updatedAt: Primitive_option.some(Scalars.DateTime.fromJsDate(new Date()))
  };
}

let context = React.createContext({
  mode: "New"
});

function use$4() {
  return React.useContext(context);
}

let make = context.Provider;

let Provider = {
  make: make
};

let ModeContext = {
  context: context,
  use: use$4,
  Provider: Provider
};

function useSetDraft() {
  let data = use$3(undefined, "store-only", undefined, undefined);
  let environment = RescriptRelayReact.useEnvironmentFromContext();
  let setDraft = draft => commitLocalPayload$1(environment, undefined, {
    localDraft: Stdlib_Option.map(draft, localDraftToCommitable)
  });
  return [
    data,
    setDraft
  ];
}

let convertVariables$2 = PropertyWizardFormRelayMutation_graphql.Internal.convertVariables;

let convertResponse$2 = PropertyWizardFormRelayMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$2 = PropertyWizardFormRelayMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables$2, PropertyWizardFormRelayMutation_graphql.node, convertResponse$2, convertWrapRawResponse$2);

let use$5 = RescriptRelay_Mutation.useMutation(convertVariables$2, PropertyWizardFormRelayMutation_graphql.node, convertResponse$2, convertWrapRawResponse$2);

let SaveDraftMutation_forSalePropertyTypeEnumV5_decode = PropertyWizardFormRelayMutation_graphql.Utils.forSalePropertyTypeEnumV5_decode;

let SaveDraftMutation_forSalePropertyTypeEnumV5_fromString = PropertyWizardFormRelayMutation_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

let SaveDraftMutation_leaseLengthValue_decode = PropertyWizardFormRelayMutation_graphql.Utils.leaseLengthValue_decode;

let SaveDraftMutation_leaseLengthValue_fromString = PropertyWizardFormRelayMutation_graphql.Utils.leaseLengthValue_fromString;

let SaveDraftMutation_mlsListingTypeV5_decode = PropertyWizardFormRelayMutation_graphql.Utils.mlsListingTypeV5_decode;

let SaveDraftMutation_mlsListingTypeV5_fromString = PropertyWizardFormRelayMutation_graphql.Utils.mlsListingTypeV5_fromString;

let SaveDraftMutation_rentalPropertyTypeEnumV5_decode = PropertyWizardFormRelayMutation_graphql.Utils.rentalPropertyTypeEnumV5_decode;

let SaveDraftMutation_rentalPropertyTypeEnumV5_fromString = PropertyWizardFormRelayMutation_graphql.Utils.rentalPropertyTypeEnumV5_fromString;

let SaveDraftMutation_showingTypeV5_decode = PropertyWizardFormRelayMutation_graphql.Utils.showingTypeV5_decode;

let SaveDraftMutation_showingTypeV5_fromString = PropertyWizardFormRelayMutation_graphql.Utils.showingTypeV5_fromString;

let SaveDraftMutation = {
  forSalePropertyTypeEnumV5_decode: SaveDraftMutation_forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: SaveDraftMutation_forSalePropertyTypeEnumV5_fromString,
  leaseLengthValue_decode: SaveDraftMutation_leaseLengthValue_decode,
  leaseLengthValue_fromString: SaveDraftMutation_leaseLengthValue_fromString,
  mlsListingTypeV5_decode: SaveDraftMutation_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: SaveDraftMutation_mlsListingTypeV5_fromString,
  rentalPropertyTypeEnumV5_decode: SaveDraftMutation_rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: SaveDraftMutation_rentalPropertyTypeEnumV5_fromString,
  showingTypeV5_decode: SaveDraftMutation_showingTypeV5_decode,
  showingTypeV5_fromString: SaveDraftMutation_showingTypeV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$2,
  convertResponse: convertResponse$2,
  convertWrapRawResponse: convertWrapRawResponse$2,
  commitMutation: commitMutation,
  use: use$5
};

function localDraftToDraftPropertyInput(draft) {
  let match = draft.draftProperty;
  let tmp;
  tmp = match.propertyType === "FOR_SALE" ? ({
      commission: match.commission,
      forSalePropertyType: match.forSalePropertyType
    }) : undefined;
  let match$1 = draft.draftProperty.geocodingData;
  let match$2 = draft.draftProperty;
  let tmp$1;
  tmp$1 = match$2.propertyType === "FOR_SALE" ? undefined : ({
      availableFrom: match$2.availableFrom,
      commission: match$2.commission,
      leaseLength: match$2.leaseLength,
      rentalPropertyType: match$2.rentalPropertyType
    });
  return {
    anonymousProperty: draft.draftProperty.anonymousProperty,
    baths: draft.draftProperty.baths,
    beds: draft.draftProperty.beds,
    description: draft.draftProperty.description,
    displayNeighborhoodId: Stdlib_Option.map(draft.draftProperty.displayNeighborhood, dn => dn.id),
    files: draft.draftProperty.files.map(file => ({
      contentType: file.contentType,
      fileName: file.fileName,
      id: file.id,
      key: file.key
    })),
    forSaleProperty: tmp,
    geocodingData: match$1 !== undefined ? ({
        lat: match$1.lat,
        lon: match$1.lon,
        standardizedAddress: match$1.standardizedAddress,
        standardizedCity: match$1.standardizedCity,
        standardizedState: match$1.standardizedState,
        standardizedZip: match$1.standardizedZip
      }) : undefined,
    goingOnMls: draft.draftProperty.goingOnMls,
    halfBaths: draft.draftProperty.halfBaths,
    hideAddress: draft.draftProperty.hideAddress,
    images: draft.draftProperty.images.map(image => ({
      contentType: image.contentType,
      fileName: image.fileName,
      id: image.id,
      key: image.key
    })),
    livingArea: draft.draftProperty.livingArea,
    lotSize: draft.draftProperty.lotSize,
    mlsListingType: draft.draftProperty.mlsListingType,
    numberOfUnits: draft.draftProperty.numberOfUnits,
    onMlsAt: draft.draftProperty.onMlsAt,
    parkingDetails: draft.draftProperty.parkingDetails,
    parkingSpaces: draft.draftProperty.parkingSpaces,
    price: {
      exactPrice: draft.draftProperty.priceRange ? undefined : ({
          price: Stdlib_Option.map(draft.draftProperty.price, Scalars.PriceInput.fromInt)
        }),
      priceRange: draft.draftProperty.priceRange ? ({
          maxPrice: Stdlib_Option.map(draft.draftProperty.maxPrice, Scalars.PriceInput.fromInt),
          minPrice: Stdlib_Option.map(draft.draftProperty.minPrice, Scalars.PriceInput.fromInt)
        }) : undefined
    },
    rentalProperty: tmp$1,
    selectedAreaId: Stdlib_Option.map(draft.draftProperty.selectedArea, area => area.id),
    showings: draft.draftProperty.showings.map(s => ({
      date: s.date,
      endTime: s.endTime,
      id: s.id,
      key: s.key,
      notes: s.notes,
      startTime: s.startTime,
      type: s.type_
    })),
    streetAddress: draft.draftProperty.address,
    website: draft.draftProperty.website,
    willAcceptOffers: draft.draftProperty.willAcceptOffers,
    willShow: draft.draftProperty.willShow
  };
}

let saveDraftMutationDisposables = {
  contents: []
};

let saveDraftMutationTimeout = {
  contents: undefined
};

function useSaveLocalProperty() {
  let formContext = React.useContext(context);
  let match = use$5();
  let saveDraft = match[0];
  let match$1 = useSetDraft();
  let setDraft = match$1[1];
  let updateFormState = useUpdater();
  let preloadPreviewQuery = PropertyWizardRelay__Preview__Query.usePreloadPreviewQuery();
  let match$2 = React.useTransition();
  let startSyncServerDraftTransition = match$2[1];
  let draftId = Stdlib_Option.flatMap(match$1[0].localDraft, ld => ld.serverDraftId);
  let saveDraft$1 = draft => {
    updateFormState(fs => {
      let match = fs.draftSaveStatus;
      let tmp;
      tmp = match === "NotSaved" ? "FirstSaveInProgress" : "SaveInProgress";
      fs.draftSaveStatus = tmp;
    });
    let propertyInput = localDraftToDraftPropertyInput(draft);
    let match = formContext.mode;
    let propertyIdForDraft;
    if (draftId !== undefined || typeof match !== "object") {
      propertyIdForDraft = undefined;
    } else {
      switch (match.TAG) {
        case "Edit" :
          propertyIdForDraft = undefined;
          break;
        case "Rebroadcast" :
        case "BroadcastQuietSeller" :
          propertyIdForDraft = match._0;
          break;
      }
    }
    let disposableFromSave = saveDraft({
      input: {
        draftId: draftId,
        message: draft.message,
        property: propertyInput,
        propertyId: propertyIdForDraft,
        subject: draft.subject
      }
    }, undefined, undefined, undefined, (response, _mutationErrors) => {
      updateFormState(fs => {
        fs.draftSaveStatus = "Saved";
      });
      let saveListingDraftV5 = response.saveListingDraftV5;
      if (saveListingDraftV5 !== undefined) {
        startSyncServerDraftTransition(() => setDraft(serverDraftToLocalDraft(RescriptRelay_Fragment.readInlineData(PropertyWizardFormRelay_inlineServerDraft_graphql.node, convertFragment$3, saveListingDraftV5.fragmentRefs))));
      }
      preloadPreviewQuery(propertyInput);
    }, _mutationError => updateFormState(fs => {
      fs.draftSaveStatus = "SaveFailed";
    }), undefined);
    saveDraftMutationDisposables.contents.forEach(prim => {
      prim.dispose();
    });
    saveDraftMutationDisposables.contents = [disposableFromSave];
  };
  let saveDraft$2 = localDraft => {
    saveDraftMutationDisposables.contents.forEach(prim => {
      prim.dispose();
    });
    saveDraftMutationDisposables.contents = [];
    let timeoutId = saveDraftMutationTimeout.contents;
    if (timeoutId !== undefined) {
      clearTimeout(Primitive_option.valFromOption(timeoutId));
      saveDraftMutationTimeout.contents = undefined;
    }
    saveDraftMutationTimeout.contents = Primitive_option.some(setTimeout(() => {
      saveDraft$1(localDraft);
      saveDraftMutationTimeout.contents = undefined;
    }, 750));
  };
  let match$3 = formContext.mode;
  if (typeof match$3 !== "object" || match$3.TAG !== "Edit") {
    return saveDraft$2;
  } else {
    return draft => preloadPreviewQuery(localDraftToDraftPropertyInput(draft));
  }
}

function composeUpdaters(updaters) {
  return draftProperty => Stdlib_Array.reduce(updaters, draftProperty, (draftProperty, updater) => updater(draftProperty));
}

let context$1 = React.createContext({
  scheduleUpdate: param => {}
});

function use$6() {
  return React.useContext(context$1);
}

let make$1 = context$1.Provider;

let Provider_ = {
  make: make$1
};

function PropertyWizardFormRelay$UpdaterContext$Provider(props) {
  let match = useSetDraft();
  let setDraft = match[1];
  let data = match[0];
  let saveDraft = useSaveLocalProperty();
  let draft = useOpt(Stdlib_Option.map(data.localDraft, l => l.fragmentRefs));
  let mostRecentDraftData = React.useRef(draft);
  mostRecentDraftData.current = draft;
  let match$1 = React.useState(() => []);
  let setPendingUpdates = match$1[1];
  let pendingUpdates = match$1[0];
  let match$2 = React.useState(() => false);
  let setIsWaitingForPropagation = match$2[1];
  let isWaitingForPropagation = match$2[0];
  let match$3 = React.useTransition();
  let startApplyLocalDraftUpdatesTransition = match$3[1];
  React.useEffect(() => {
    if (pendingUpdates.length !== 0 && !isWaitingForPropagation) {
      let updater = composeUpdaters(pendingUpdates);
      let currentDraft = mostRecentDraftData.current;
      let newDraft = currentDraft !== undefined ? updater(currentDraft) : undefined;
      setIsWaitingForPropagation(param => true);
      setPendingUpdates(u => u.filter(u => pendingUpdates.every(u_ => u !== u_)));
      startApplyLocalDraftUpdatesTransition(() => setDraft(newDraft));
      if (newDraft !== undefined) {
        saveDraft(newDraft);
      }
    }
  }, [
    pendingUpdates,
    isWaitingForPropagation
  ]);
  React.useEffect(() => {
    setIsWaitingForPropagation(param => false);
  }, [Stdlib_Option.map(data.localDraft, x => x.updatedAt)]);
  return JsxRuntime.jsx(make$1, {
    value: {
      scheduleUpdate: updater => setPendingUpdates(pendingUpdates => pendingUpdates.concat([updater]))
    },
    children: props.children
  });
}

let Provider$1 = {
  make: PropertyWizardFormRelay$UpdaterContext$Provider
};

let UpdaterContext = {
  context: context$1,
  use: use$6,
  Provider_: Provider_,
  Provider: Provider$1
};

function useUpdateDraft() {
  return React.useContext(context$1).scheduleUpdate;
}

function use$7() {
  return React.useContext(context);
}

function PropertyWizardFormRelay$Context$Provider(props) {
  return JsxRuntime.jsx(make, {
    value: {
      mode: props.mode
    },
    children: JsxRuntime.jsx(PropertyWizardFormRelay$UpdaterContext$Provider, {
      children: props.children
    })
  });
}

let Provider$2 = {
  make: PropertyWizardFormRelay$Context$Provider
};

let Context = {
  use: use$7,
  Provider: Provider$2
};

function useUpdateDraftProperty() {
  let match = React.useContext(context$1);
  let scheduleUpdate = match.scheduleUpdate;
  return updater => scheduleUpdate(draft => ({
    chapterPreferenceMlsComingSoonActivated: draft.chapterPreferenceMlsComingSoonActivated,
    draftProperty: updater(draft.draftProperty),
    message: draft.message,
    serverDraftId: draft.serverDraftId,
    status: draft.status,
    subject: draft.subject,
    timeZone: draft.timeZone
  }));
}

function getEmptyLocalDraft(draftId, defaultTimezone) {
  return {
    chapterPreferenceMlsComingSoonActivated: false,
    draftProperty: {
      address: undefined,
      addressToGeocode: undefined,
      anonymousProperty: false,
      availableFrom: undefined,
      baths: undefined,
      beds: undefined,
      commission: undefined,
      description: undefined,
      displayNeighborhood: undefined,
      files: [],
      forSalePropertyType: undefined,
      geocodingData: undefined,
      goingOnMls: undefined,
      halfBaths: undefined,
      hideAddress: undefined,
      images: [],
      leaseLength: undefined,
      livingArea: undefined,
      lotSize: undefined,
      maxPrice: undefined,
      minPrice: undefined,
      mlsListingType: "ACTIVE",
      numberOfUnits: undefined,
      onMlsAt: undefined,
      parkingDetails: undefined,
      parkingSpaces: undefined,
      price: undefined,
      priceRange: false,
      propertyType: "FOR_SALE",
      rentalPropertyType: undefined,
      selectedArea: undefined,
      showings: [],
      website: undefined,
      willAcceptOffers: true,
      willShow: true
    },
    message: undefined,
    serverDraftId: draftId,
    status: undefined,
    subject: undefined,
    timeZone: defaultTimezone
  };
}

function useInitForm(draftData, draftDbId, param) {
  let match = React.useState(() => false);
  let setInitialized = match[1];
  let match$1 = React.useContext(context);
  let mode = match$1.mode;
  let defaultTimezone = DateFnsTz.Timezone.toString(UserSession.useChapterTimezone());
  let environment = RescriptRelayReact.useEnvironmentFromContext();
  let updateFormState = useUpdater();
  let match$2 = useSetDraft();
  let setDraft = match$2[1];
  React.useEffect(() => {
    let draftData$1 = draftData !== undefined ? draftData : getEmptyLocalDraft(draftDbId, defaultTimezone);
    setDraft(draftData$1);
    let stepsInitiallyTouched;
    if (typeof mode !== "object") {
      stepsInitiallyTouched = false;
    } else {
      switch (mode.TAG) {
        case "Edit" :
        case "Rebroadcast" :
          stepsInitiallyTouched = true;
          break;
        case "BroadcastQuietSeller" :
          stepsInitiallyTouched = false;
          break;
      }
    }
    commitLocalPayload(environment, undefined, {
      localDraftFormState: {
        __typename: "LocalDraftFormState"
      }
    });
    updateFormState(formState => {
      formState.stepDescriptionTouched = stepsInitiallyTouched;
      formState.stepKeyFactsTouched = stepsInitiallyTouched;
      formState.stepMlsTimingTouched = stepsInitiallyTouched;
      formState.stepShowingsTouched = stepsInitiallyTouched;
      formState.stepPhotosAndFilesTouched = stepsInitiallyTouched;
      formState.filesStatus = [];
      formState.imagesStatus = [];
      setDisplayNeighborhoods(formState, []);
    });
    setInitialized(param => true);
  }, []);
  return match[0];
}

let PreviewQuery;

exports.PolicyFragment = PolicyFragment;
exports.FormState = FormState;
exports.LocalDraftFragment = LocalDraftFragment;
exports.ServerDraftFragment = ServerDraftFragment;
exports.InlineServerDraftFragment = InlineServerDraftFragment;
exports.serverDraftToLocalDraft = serverDraftToLocalDraft;
exports.LocalDraftSetterQuery = LocalDraftSetterQuery;
exports.localDraftToCommitable = localDraftToCommitable;
exports.ModeContext = ModeContext;
exports.useSetDraft = useSetDraft;
exports.SaveDraftMutation = SaveDraftMutation;
exports.localDraftToDraftPropertyInput = localDraftToDraftPropertyInput;
exports.PreviewQuery = PreviewQuery;
exports.saveDraftMutationDisposables = saveDraftMutationDisposables;
exports.saveDraftMutationTimeout = saveDraftMutationTimeout;
exports.useSaveLocalProperty = useSaveLocalProperty;
exports.composeUpdaters = composeUpdaters;
exports.UpdaterContext = UpdaterContext;
exports.useUpdateDraft = useUpdateDraft;
exports.Context = Context;
exports.useUpdateDraftProperty = useUpdateDraftProperty;
exports.getEmptyLocalDraft = getEmptyLocalDraft;
exports.useInitForm = useInitForm;
/* use Not a pure module */
